import { SelectProps } from 'antd/lib'
import { useMemo } from 'react'

import { useNotificationsServiceGetChannelsListEndpoint } from 'src/api/queries'
import { Select } from 'src/components'
import { useLocales } from 'src/locales'

export const ChannelsSelect = (props: SelectProps) => {
  const { t } = useLocales()

  const { data, isLoading } = useNotificationsServiceGetChannelsListEndpoint()

  const options = useMemo(
    () =>
      data?.data?.map((item) => ({
        value: item.id,
        label: item.name
      })),
    [data]
  )

  return (
    <Select
      options={options}
      loading={isLoading}
      placeholder={t('notification_templates.chanel')}
      {...props}
    />
  )
}
